<section id="services" class="services-section py-24 relative overflow-hidden">
  <div class="services-bg" aria-hidden="true"></div>

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
    <div class="text-center mb-14">
      <span class="section-badge">Our Offerings</span>
      <h2 class="text-4xl sm:text-5xl font-bold mt-4 mb-4">
        Services We <span class="gradient-text">Deliver</span>
      </h2>
      <p class="text-slate-600 max-w-2xl mx-auto text-lg">
        Custom software, web platforms, and mobile apps — designed, built, and shipped end to end by Trieon Technologies.
      </p>
      <div class="section-underline"></div>
    </div>

    <div class="services-grid">
      @for (service of services; track service.title) {
        <article class="service-card" [attr.data-tone]="service.tone">
          <div class="service-card__top">
            <span class="service-step">{{ service.step }}</span>
            <div class="service-icon">
              <i class="pi" [class]="service.icon"></i>
            </div>
          </div>

          <h3>{{ service.title }}</h3>
          <p class="service-desc">{{ service.description }}</p>

          <ul class="service-points">
            @for (point of service.points; track point) {
              <li>{{ point }}</li>
            }
          </ul>

          <div class="service-tags">
            @for (tag of service.tags; track tag) {
              <span class="service-tag">{{ tag }}</span>
            }
          </div>
        </article>
      }
    </div>
  </div>
</section>
